import React, { Component } from "react";

export default class DataScienceImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="fa973782-3a18-4630-a762-87130b613ac3"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        width="1000"
        height="829.80067"
        viewBox="0 0 1120 829.80067"
      >
        <title>SBE </title>

        {/* Embed the image here */}
        <image
          x="100"
          y="100"
          width="900"
          height="800"
          href="https://i.ibb.co/TTNBQx6/Untitled-design-6.png"
        />

        <ellipse
          cx="555.57906"
          cy="811.05902"
          rx="144.42094"
          ry="18.74165"
          fill={theme.text}
        />
        {/* Other SVG content remains the same */}
      </svg>
    );
  }
}
